import React from 'react';
import './TaskList.css';
import { FaRegClock } from 'react-icons/fa';

const TaskList = () => {
  const tasks = [
    // Immediate Daily Tasks
    {
      id: 1,
      title: 'Load #LTX-4521 - Tracking Update Needed',
      tags: ['Urgent', 'In Transit'],
      time: '1 hour ago',
      details: 'Last tracking update >24 hours ago.',
      category: 'Immediate Daily Tasks',
    },
    {
      id: 2,
      title: 'Overnight Catch-up',
      tags: ['Report', 'High Priority'],
      time: '30 minutes ago',
      details: 'Review critical updates from the night shift.',
      category: 'Immediate Daily Tasks',
    },
    {
      id: 3,
      title: 'Urgent Tracking Check',
      tags: ['Urgent', 'Logistics'],
      time: '1 hour ago',
      details: 'Shipment #SHP-9876 needs a tracking update. Last tracking update >24 hours ago.',
      category: 'Immediate Daily Tasks',
    },
    {
      id: 4,
      title: 'Current Day Coverage',
      tags: ['Planning', 'High Priority'],
      time: '2 hours ago',
      details: 'Prioritize open loads with immediate pickup times for the current day.',
      category: 'Immediate Daily Tasks',
    },
    {
      id: 5,
      title: 'Carrier Capacity Sourcing',
      tags: ['Sourcing', 'Scheduled'],
      time: '3 hours ago',
      details: 'Call specific carriers to gather their daily available capacity.',
      category: 'Immediate Daily Tasks',
    },
    // Strategically Prioritized Tasks
    {
      id: 6,
      title: 'Load #LTX-4489 - Detention Time Claim',
      tags: ['Action Required', 'Pending Review'],
      time: '2 days ago',
      details: 'Phoenix, AZ → Seattle, WA · Delivered: 2 days ago',
      category: 'Strategically Prioritized Tasks (Human-First)',
    },
    {
      id: 7,
      title: 'High Urgent Shipment Booking',
      tags: ['Booking', 'Critical'],
      time: '4 hours ago',
      details: 'Tasks for time-critical bookings (e.g., a truck fell off a load picking up in one hour).',
      category: 'Strategically Prioritized Tasks (Human-First)',
    },
    {
      id: 8,
      title: 'Lane Liquidity Building',
      tags: ['Strategic', 'Networking'],
      time: '5 hours ago',
      details: 'Communicate with specific carriers to invest in and increase coverage/capacity on important lanes.',
      category: 'Strategically Prioritized Tasks (Human-First)',
    },
    {
      id: 9,
      title: 'Relationship Management Calls',
      tags: ['Networking', 'Follow-up'],
      time: '6 hours ago',
      details: 'Call carriers to maintain the connection, especially if there hasn\'t been communication recently.',
      category: 'Strategically Prioritized Tasks (Human-First)',
    },
    {
      id: 10,
      title: 'Issue Resolution',
      tags: ['Problem Solving', 'High Demand'],
      time: '7 hours ago',
      details: 'Tasks related to dealing with complex problems like detention or other high-demand issues.',
      category: 'Strategically Prioritized Tasks (Human-First)',
    },
    // Specific System-Assigned Tasks
    {
      id: 11,
      title: 'Open Invoice #INV-9821',
      tags: ['Follow-up', 'Overdue'],
      time: '6 days ago',
      details: 'Payment due: Nov 15, 2024 · Amount: $2,450.00',
      category: 'Specific System-Assigned Tasks',
    },
    {
      id: 12,
      title: 'Booking a Load',
      tags: ['System Task', 'Booking'],
      time: '8 hours ago',
      details: 'Explicitly presented as "book this load."',
      category: 'Specific System-Assigned Tasks',
    },
    {
      id: 13,
      title: 'Targeted Calls',
      tags: ['System Task', 'Follow-up'],
      time: '9 hours ago',
      details: 'Call a specific dispatcher to offer a load or follow up on information.',
      category: 'Specific System-Assigned Tasks',
    },
    {
      id: 14,
      title: 'Tracking/Onboarding',
      tags: ['System Task', 'Onboarding'],
      time: '10 hours ago',
      details: 'Follow up on digital tracking or onboarding drivers to tracking systems.',
      category: 'Specific System-Assigned Tasks',
    },
  ];

  const getTagClass = (tag) => {
    switch (tag.toLowerCase()) {
      case 'urgent': return 'tag-urgent';
      case 'in transit': return 'tag-in-transit';
      case 'action required': return 'tag-action-required';
      case 'pending review': return 'tag-pending-review';
      case 'follow-up': return 'tag-follow-up';
      case 'overdue': return 'tag-overdue';
      case 'report': return 'tag-report';
      case 'high priority': return 'tag-high-priority';
      case 'logistics': return 'tag-logistics';
      case 'planning': return 'tag-planning';
      case 'sourcing': return 'tag-sourcing';
      case 'scheduled': return 'tag-scheduled';
      case 'booking': return 'tag-booking';
      case 'critical': return 'tag-critical';
      case 'strategic': return 'tag-strategic';
      case 'networking': return 'tag-networking';
      case 'problem solving': return 'tag-problem-solving';
      case 'high demand': return 'tag-high-demand';
      case 'system task': return 'tag-system-task';
      case 'onboarding': return 'tag-onboarding';
      default: return 'tag-default';
    }
  };

  const renderTasks = (category) => {
    const filteredTasks = tasks.filter(task => task.category === category);
    return (
      <div className="task-category">
        <h3>{category}</h3>
        <div className="task-list-items">
          {filteredTasks.map(task => (
            <div key={task.id} className="task-item">
              <div className="task-header">
                <div className="task-tags">
                  {task.tags.map(tag => (
                    <span key={tag} className={`tag ${getTagClass(tag)}`}>{tag}</span>
                  ))}
                </div>
                <span className="task-time"><FaRegClock /> {task.time}</span>
              </div>
              <p className="task-title">{task.title}</p>
              <p className="task-details">{task.details}</p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="task-list-container">
      <h2>Daily Task List</h2>
      {renderTasks('Immediate Daily Tasks')}
      {renderTasks('Strategically Prioritized Tasks (Human-First)')}
      {renderTasks('Specific System-Assigned Tasks')}
    </div>
  );
};

export default TaskList;